import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import constants from "@/constants";

export default class CheckState extends BossModel {

    static apiUrl = 'proposal/check-state';

    static entity = 'proposalCheckStates';

    static fields() {
        return {
            id: this.number(null).nullable(),
            state_cid: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            reason: this.attr(null),
            created_at: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
        }
    }

    IsOpen() {
        return this.state_cid === constants.checkStates.find(state => state.key === 'open').id;
    }

    IsAccepted() {
        return this.state_cid === constants.checkStates.find(state => state.key === 'accepted').id;
    }

    IsDenied() {
        return this.state_cid === constants.checkStates.find(state => state.key === 'denied').id;
    }
}
